// import cookie from '../common/cookie';
import { get } from './http';

// let token = cookie.getCookie('GEESE_TOKEN');
var api = {
    // 获取首页数据
    getHomeData(p) {
        return get('/jxsf/open/home', p);
    },
    // banner列表
    picList(p) {
        return get('/auth/pic/list', p);
    },
    // 文章列表
    arcList(p) {
        return get('/auth/arc/list', p);
    },
    // 文章详情
    getArcDetail(p) {
        return get('/auth/arc/detail', p);
    },
    // 联系人列表
    contactList(p) {
        return get('/auth/contact/list', p);
    },
    // 文件列表
    fileList(p) {
        return get('/auth/file/list', p);
    },
    // 文件详情
    getFileDetail(p) {
        return get('/auth/file/detail', p);
    },
    // 友情链接列表
    linkList(p) {
        return get('/auth/link/list', p);
    },

    // 站内搜索
    searchList(p) {
        return get('/jxsf/open/findByKey', p);
    },

};

// function setToken(obj) {
//     obj.token = cookie.getCookie('GEESE_TOKEN');
// }

export default api;
